import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleLeft, faAngleRight, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

const DatatablePagination = ({ rows, effectivePage, effectivePerPage, effectiveTotal, totalPages, rowsPerPageOptions, manualPageInput, manualInputPage, setManualInputPage, handlePageChange, handlePerPageChange }) => {
  return (
    <div className="d-flex justify-content-center justify-content-md-end align-items-center w-100">
      <div className="datatable-pagination-wrapper mx-2 mx-md-3 d-flex flex-column flex-md-row align-items-center gap-3">
        <div className="d-flex align-items-center justify-content-center gap-2 datatable-pagination-select-container">
          <span className="datatable-pagination-info">Filas por página:</span>
          <select value={effectivePerPage} onChange={handlePerPageChange} className="form-select form-select-sm datatable-pagination-select-input">
            {rowsPerPageOptions.map(opt => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>

        <div className="text-muted datatable-pagination-info text-center">
          Mostrando <strong>{rows.length > 0 ? (effectivePage - 1) * effectivePerPage + 1 : 0}</strong>–<strong>{Math.min(effectivePage * effectivePerPage, effectiveTotal)}</strong> de <strong>{effectiveTotal}</strong> registros
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-center gap-1 gap-sm-2 datatable-pagination-controls">
          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(1)} disabled={effectivePage === 1} title="Ir al inicio">
            <FontAwesomeIcon icon={faAngleDoubleLeft} />
          </button>
          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(effectivePage - 1)} disabled={effectivePage <= 1} title="Página anterior">
            <FontAwesomeIcon icon={faAngleLeft} />
          </button>

          <span className="datatable-pagination-info">
            {manualPageInput ? (
              <>
                Página{" "}
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={effectivePage}
                  onChange={e => {
                    const txt = e.target.value.replace(/\D/g, "");
                    handlePageChange(txt);
                  }}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      const val = Number(effectivePage);
                      if (val >= 1 && val <= totalPages) handlePageChange(val)
                      else handlePageChange(val);
                    }
                  }}
                  className="datatable-pagination-manual-input"
                />{" "}
                de {totalPages}
              </>
            ) : (
              <>
                Página {effectivePage} de {totalPages}
              </>
            )}
          </span>

          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(parseInt(effectivePage) + 1)} disabled={effectivePage >= totalPages} title="Página siguiente">
            <FontAwesomeIcon icon={faAngleRight} />
          </button>
          <button type="button" className="btn btn-sm btn-outline-primary datatable-pagination-btn-custom" onClick={() => handlePageChange(totalPages)} disabled={effectivePage === totalPages} title="Ir al final">
            <FontAwesomeIcon icon={faAngleDoubleRight} />
          </button>
        </div>
      </div>
    </div>
  );
};

DatatablePagination.propTypes = {
  rows: PropTypes.array.isRequired,
  effectivePage: PropTypes.number.isRequired,
  effectivePerPage: PropTypes.number.isRequired,
  effectiveTotal: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired,
  manualPageInput: PropTypes.bool,
  manualInputPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setManualInputPage: PropTypes.func,
  handlePageChange: PropTypes.func.isRequired,
  handlePerPageChange: PropTypes.func.isRequired,
};

export default DatatablePagination;
